import { useSelector } from "react-redux";
import { MdVerified } from "react-icons/md";
import { styled } from "@mui/material/styles";
import { Fragment, useEffect, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { IoIosInformationCircle } from "react-icons/io";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import ImagePopup from "./ImagePopup";
import { useAxios } from "../../hooks";
import AddGuardian from "./AddGuardian";
import UserDetailPopUp from "./UserDetailPopUp";
import LoadingButton from "../../components/LoadingButton";
import { getVisitorFaceData } from "../../utils/getVisitorFaceData";
import Color from "../../theme/color";

const TableCells = styled(TableCell)``;

const OuterBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
  background: #ffffff;
`;

const OuterPaper = styled(Box)`
  width: 100%;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.5);
  align-content: center;
`;

export default function CampusSummary() {
  const axios = useAxios();
  const navigate = useNavigate();
  const { state, search } = useLocation();
  const { visitorData } = useSelector((state) => state.memberDetails);

  const [open, setOpen] = useState(false);

  const [guardian, setGuardian] = useState(false);
  const [premises, setPremisesData] = useState([]);

  const queryParams = new URLSearchParams(search);

  const [userData, setUserData] = useState(state);
  const entityId = queryParams.get("entity_id");
  const bookingId = queryParams.get("booking_id");
  const visitorId = queryParams.get("visitor_id");
  const userTypeID = queryParams.get("user_type_id");
  const digiLockerID = queryParams.get("id");

  const userPayloadString = localStorage.getItem(
    `userPayload_${visitorData.ID}`
  );
  const userPayload = JSON.parse(userPayloadString);

  const [userDetial, setUserDetial] = useState([]);
  const [entityDetails, setEntityDetails] = useState({});
  const [userDetialPopUp, setUserDetialPopUp] = useState(false);

  let localStorageData = { ...localStorage };

  const digipassDataKey = Object.keys(localStorageData).filter((item) => {
    return item.includes(visitorData.ID) && !item.includes("userPayload");
  });

  useEffect(() => {
    axios({
      url: `/admin/profile/get-premises-banner?premises_id=` + entityId,
      disableRedirect: true,
      disableError: true,
    }).then((response) => {
      if (response.status) {
        setPremisesData(response.data);
      }
    });
  }, []);

  useEffect(() => {
    let faceData = digipassDataKey.filter((item) => {
      return localStorage.getItem(item);
    });
    if (digiLockerID) {
      axios({
        url: "event/govt-api/get-user-document",
        method: "POST",
        data: {
          document_type: "aadhar",
          request_id: digiLockerID,
          visitor_id: visitorData.ID,
          document_verification: true,
          is_encrypted_face: true,
          face_data: localStorage.getItem(faceData[0]),
        },
      }).then((response) => {
        if (response.status) {
          let key = visitorData.ID;
          localStorage.setItem(key, response.data.encrypted_face_data);
        }
      });
    }
  }, []);

  useEffect(() => {
    let url = "admin/profile/get-visitor-booking-status";

    let method = "POST";

    let data = {
      visitor_id: visitorId,
      entity_id: entityId,
      user_type_id: userTypeID,
      booking_id: bookingId,
      face_data: getVisitorFaceData(visitorId),
    };

    axios({
      url: url,
      disableRedirect: true,
      method: method,
      data: data,
    }).then((response) => {
      if (response.status) {
        setUserData({ userData: response.data });
      }
    });
  }, [axios]);

  useEffect(() => {
    if (entityId) {
      axios({
        url: "/admin/business/entity_details?entity_id=" + entityId,
        disableRedirect: true,
        disableError: true,
      }).then((response) => {
        if (response.status) {
          setEntityDetails(response.data);
        }
      });
    }
  }, []);

  const renderInfoItem = (label, value) => (
    <TableRow>
      <TableCells sx={{ width: "40%" }}>
        <Typography
          variant="body1"
          style={{ color: "rgb(150 150 150)" }}
          fontWeight={900}
        >
          {label}
        </Typography>
      </TableCells>
      <TableCells sx={{ width: "60%" }}>
        <Tooltip title={value}>
          <Typography
            variant="h6"
            fontWeight={900}
            sx={{
              color: value === "pending" ? "red" : "black",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "1rem",
              "@media (max-width: 425px)": {
                fontSize: "0.875rem",
              },
            }}
          >
            {value?.toUpperCase()}
          </Typography>
        </Tooltip>
      </TableCells>
    </TableRow>
  );

  return (
    <Fragment>
      <Paper
        elevation={3}
        sx={{
          padding: "5px 12px 12px",
          borderRadius: 2,
          mt: 4,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid
          container
          sx={{
            "@media (min-width:950px)": { width: "50%" },
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              textTransform: "uppercase",
              letterSpacing: 1,
              marginBottom: 3,
              fontWeight: 900,
            }}
          >
            Campus Summary
          </Typography>

          <Box
            component="img"
            src={
              premises.premises_banner ||
              entityDetails.banner_image ||
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAMAAAAGjUrGAAAAllBMVEX///8mJykAAAAmJysjJCYnJykGCA3//v/Iycnf398gISMXGBsAAAcZGh0lKCpISUsNDxJAQUMSFBfS0tKHh4np6emqqqq/v7/39/csLS+2trZYWFng4OBSUlTX19ceICB6e3wzNDZtbW2enp/u7/BlZmiVlpimpqaGhoePj5A7PD4yMzW6urtWWFdXV1lMTE92dnUVGBa2GMXKAAAGfUlEQVR4nO2Z6XLqOBCFJSEvyDbIJoAx+5aw3ZC8/8tNt2QTstypmT8XT835qlKRsJCl41YvWAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/H/olo9eQcsYvvTV6NGLaBO70dRaYy+PXkd7WKyVNTII7PjRK2kPXZtJSZqE8aNX0iKizVLKjoQm9wxCaPKVroImX4Em34Em34Em34Em34EmN4ZN47+uSbm4jKp45tpR9NOIKCojwX/c9rXuLh5tt6N4eDeqrE6K/nW3z4tPmtCcZbkbLuLq+dF18mDSn//69WtKvL6+uv/T+bWfn5YzMT315/P59XSl2uRNK6XSMO1XtPpgnfe/kOen9STciq1d58RakXrVa5imKrWh6o/8PqPBSodZLnZ7ZQtVzT40WbxPJjqzKd1FLR4rieie1ZIxJimCiQmtcdjlfChWuqBmOjmIlcpMOF/NrTRqH4mNqYeZYn06mZAa2ujMvMZifM3465N9Ga9Do+38uCl0YGxAG++uZEoljs4rw5WOPs3SmybD6dpoKRPzFO8eLAnRPRkuxcyeH+VuVVBHJlt/bZUF4VhEfdLixE9vZGVgN/S8D26Ylm79ceEmmPrvxFbaZyG2iqa1PM9iSZvVaitGSvO3Aq0sN/S5m977k1xrtXr0ualZpG5Lfd+7ml6vlx18Z28K2t41kzrZ0ZmJxFrLQPEechZS2pn7dFvwTicRI0aFmZN6KujIbONmqUIeqyoxTmjuXpA9vWQ0pX0b3vvYF2uy9njb/dKteeA6vD+pjXteu5Qbz7SlRqRcBzJ7o8bY7TNbUTMSi5C2JkP/29DVpLHgUyFl6qcUay/gjuyOG0Uphnv1vinZn0jWhPzyWBX9oWgNXbc0s3edg1u2feH2S0FmsnMi9UdVVY02WRBIk/M1byhqx5rEThM2D5osZYvbO4eR1Tc4JtTrFEffkIY/25XNjZ2dxCrb/xjNHsXG6ZCyx4gm7szrCX9O7rMkm3YWwQFBhVmWJfbE18bOEpIja/KWsSbe0o5FOhY7r/K1nj92RqVPXhOtm/t+aBJbXWz/+L7/jq7bnzv9FQURZwAXdjTFkxBT44zo6XA4PDmOPlb23bh3MpRhqJNOY2mTZd6crNryeIB0c5YfmjjX4zXJni6rUPdk0aKjIxpDUV0hzsnGi0A7WyUF7Viy4aRf1xvV+34nQzkUE+eFJGUW45Tdiu86x8OUCftSqWYfZ+dOExmqJOj16rPXGuoHticzUbM4DViFuHxPVrT45N5b3pObHnuecmjJ+5y1t7TX7EyXnoub4TGllrTnRhNt7m/bo/N3eXcHNnz+I5v9pzifSCf7VNCznTtDeX2xKafyGa/3p8PuDCVIjodkEnHmwsMu1vLbGm8ntwdfSu002f2oCfmTyhvMwzPYTwycR9HGhDOOAW5H2j9nF2D06YcvuWRPUtbKMvRcGpZpzVHcnyvdqweWGduJXoovmswaTcTGH6pzS1I2j3MiPZ9weEPpBP6xPbnl2jtDaXyLz8UoRlHpVxuKLJz9+7hz80LkY0kTkvi3mpTu7MlkI1rEoLZet4uYraZTJ+uL2hG+NENXqq6OOasl12n9u00XxPW7r1Y2GSWssqjfevpYTPnvd006dX7S3L9VAdmF1iZSuE5Th/igJMN9zJbd3au8+c7Idjp1KiN8HuPtTLg8tldndxSYWIqEIvPRTdWkcpwDsKbuPeDW6Rak7Unv6xwsHH50bi6knLgiUVLRfMpNmnzkEZHRncZMKLhoDi31pcrVe/bI7RlvNzmRom8+SW4q37FlTQq2wMif3kDbNolCvrR5yoJPhb297h+uXRhx6ZbOkoW4JeHboqPPTYcC8C1L4/1ywApXi+GFTpVRUypyxt7iMvqwFOViTLfssD+qBqVYrPyb0iCcbuO2uNpLepeZVWFdBjqiJ2v51w1tErW//3mjzHRa3TpWq7s0ZrcqbGaKlAqCIs0pkXtTynqoSthT5Uy1giNVqiqbTsg1RGts5aQOt3Z5Vp8SqOFof07ssn/8kkE8fzgX8hZq+unirlpdyUby/bOTKt5yHekYbcdiWI3HcTwYDOJ4XO3ExXe4P67aYickxG87jh9/hW1VLQsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAf89f2L1nqm5zcBsAAAAASUVORK5CYII="
            }
            alt="Event Banner"
            sx={{
              width: "100%",
              borderRadius: "12px",
              boxShadow: 2,
              mb: 3,
              objectFit: "fill",
              maxHeight: { xs: 110, sm: 190 },
            }}
          />

          <Grid container spacing={2} alignItems="center" mt={2}>
            <Grid container justifyContent={"space-around"}>
              <Grid item xs={4} md={2} textAlign={"center"}>
                <Typography variant="subtitle2" color="text.secondary">
                  Campus Name
                </Typography>
              </Grid>
            </Grid>

            <Grid container justifyContent={"space-around"}>
              <Grid item xs={4} textAlign={"center"}>
                <Typography variant="body1" fontWeight={600}>
                  {entityDetails.campus_name || "Not Found"}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <OuterBox>
        {userData?.userData?.map((item, index) => {
          return (
            <OuterPaper
              sx={{
                padding: {
                  xs: index != 0 ? "10px 0px 0px 0px" : "20px 0px 0px 0px",
                  sm: index != 0 ? "0px" : "0px",
                },
              }}
            >
              {userData?.userData[index]?.visitor_info?.first_name && (
                <Grid
                  item
                  container
                  sx={{
                    border: "0.6px solid #0000001A",
                    borderRadius: "8px",
                    marginTop: "7px",
                  }}
                >
                  <Grid item container p={"7.5px 0px"}>
                    <Grid item container p={"5px 0px 10px 5px"}>
                      <Grid
                        item
                        xs={3.5}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          ml: 2,
                        }}
                      >
                        <Typography
                          variant="body1"
                          fontWeight={"bolder"}
                          fontSize={"14px"}
                        >
                          {userData?.userData[index]?.visitor_info?.first_name}
                          {`${
                            userData?.userData[index]?.relation
                              ? " ( " +
                                userData?.userData[index]?.relation +
                                " )"
                              : ""
                          }`}
                        </Typography>

                        <Typography
                          variant="body1"
                          fontWeight={400}
                          fontSize={"12px"}
                        >
                          {
                            userData?.userData[index]?.visitor_info
                              ?.phone_number
                          }
                        </Typography>
                      </Grid>

                      <Grid
                        item
                        xs={8}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          borderRadius: "4px",
                          alignItems: "center",
                        }}
                      >
                        {" "}
                        <Grid item container mt={2} justifyContent={"end"}>
                          <Grid item xs={4}>
                            {" "}
                            <LoadingButton
                              variant="contained"
                              onClick={() => {
                                setUserDetial(userData?.userData[index]);
                                setUserDetialPopUp(true);
                              }}
                              style={{
                                fontSize: "12px !important",
                                padding: "5px !important",
                                marginRight: "4px",
                              }}
                            >
                              Info
                            </LoadingButton>
                          </Grid>
                          {!Boolean(
                            userData?.userData[index]?.user_type == "primary" &&
                              (index > 0
                                ? !userData?.userData[index]?.journey_status
                                    ?.qr_link
                                : true)
                          ) && (
                            <Fragment>
                              {Boolean(
                                userData?.userData[index]?.journey_status
                                  ?.page_link
                              ) && (
                                <Grid item xs={6}>
                                  <LoadingButton
                                    variant="outlined"
                                    onClick={() =>
                                      navigate(
                                        userData?.userData[index]
                                          ?.journey_status?.page_link
                                      )
                                    }
                                    disabled={
                                      !userData?.userData[index]?.visitor_info
                                        ?.is_dependent &&
                                      userData?.userData[index]?.user_type ==
                                        "secondary"
                                    }
                                    style={{
                                      fontSize: "12px !important",
                                      padding: "5px !important",
                                      border: `1px solid ${Color.digipass}`,
                                      color: Color.digipass,
                                    }}
                                    backgroundColor={"white"}
                                  >
                                    {userData?.userData[
                                      index
                                    ]?.journey_status?.user_status
                                      .toUpperCase()
                                      .replace("_", " ")}
                                  </LoadingButton>
                                </Grid>
                              )}
                            </Fragment>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </OuterPaper>
          );
        })}

        {userTypeID == 6 &&
          userData?.userData?.[0]?.journey_status?.user_status == "" && (
            <Grid
              item
              container
              xs={12}
              sx={{
                alignSelf: "center",
                justifyContent: "center",
                margin: "10px 0px",
              }}
            >
              <LoadingButton
                onClick={() => setGuardian(true)}
                variant="contained"
                style={{}}
              >
                Add Guardian
              </LoadingButton>
            </Grid>
          )}

        {Boolean(userData?.match_percentage && userPayload?.doc_type) && (
          <Grid
            container
            pt={"10px"}
            sx={{
              width: "100%",
              padding: { xs: "30px 0px 0px 0px", sm: "30px 80px 0px 80px" },
            }}
          >
            <Grid
              item
              container
              sx={{
                boxShadow: "rgb(0 0 0 / 53%) 0px 3px 15px",
                padding: "8.5px",
                borderRadius: "12.5px",
                height: "100px",
              }}
            >
              <Grid item xs={4} sx={{ position: "relative" }}>
                <img
                  width="100%"
                  height="80px"
                  style={{ objectFit: "initial" }}
                  src={"data:image/png;base64," + userPayload.doc_face_image}
                  alt="Preview"
                  style={{ borderRadius: "8px" }}
                />

                <MdVerified
                  style={{
                    color: "green",
                    bottom: "10px",
                    right: "5px",
                    fontSize: "25px",
                    position: "absolute",
                    borderRadius: "15px",
                    background: "white",
                  }}
                />
              </Grid>
              <Grid
                item
                xs={8}
                className="displayCenter"
                sx={{
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    padding: "10px",
                    fontWeight: "bold",
                    "-webkit-text-stroke": ".5px",
                  }}
                >
                  Verification Done{"  "}
                  <IoIosInformationCircle
                    style={{
                      color: "blue",
                      fontSize: "20px",
                      verticalAlign: "middle",
                    }}
                    onClick={() => setOpen(true)}
                  />
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}

        <AddGuardian
          guardian={guardian}
          setGuardian={setGuardian}
          state={userData?.userData}
          userPayload={userPayload}
        />

        <ImagePopup
          open={open}
          setOpen={setOpen}
          state={userData}
          userPayload={userPayload}
        />

        <UserDetailPopUp
          userDetial={userDetial}
          setUserDetial={setUserDetial}
          userDetialPopUp={userDetialPopUp}
          renderInfoItem={renderInfoItem}
          setUserDetialPopUp={setUserDetialPopUp}
        />
      </OuterBox>
    </Fragment>
  );
}
